// src/components/AboutSection.jsx
import React from 'react';
import PhotoSlider from './PhotoSlider';

function AboutSection({ id }) {
  // Use string concatenation for process.env.PUBLIC_URL to avoid build-time parser issues
  const aboutSliderImages = [
    { src: process.env.PUBLIC_URL + "/images/slide_12.jpeg", alt: "" },
    { src: process.env.PUBLIC_URL + "/images/slide_2.png", alt: "" },
    { src: process.env.PUBLIC_URL + "/images/slide_3.png", alt: "" },
    { src: process.env.PUBLIC_URL + "/images/slide_4.png", alt: "" },
    { src: process.env.PUBLIC_URL + "/images/slide_5.png", alt: "" },
    { src: process.env.PUBLIC_URL + "/images/slide_6.png", alt: "" },
    { src: process.env.PUBLIC_URL + "/images/slide_7.png", alt: "" },
    { src: process.env.PUBLIC_URL + "/images/slide_8.png", alt: "" },
    { src: process.env.PUBLIC_URL + "/images/slide_9.jpeg", alt: "" },
    { src: process.env.PUBLIC_URL + "/images/slide_10.jpeg", alt: "" },
    { src: process.env.PUBLIC_URL + "/images/slide_11.jpeg", alt: "" },
    { src: process.env.PUBLIC_URL + "/images/slide_13.jpeg", alt: "" },
    { src: process.env.PUBLIC_URL + "/images/slide_14.png", alt: "" },
    
  ];

  return (
    <section id={id} className="scroll-target py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Text Section */}
          <div>
            <h2 className="text-4xl font-bold text-gray-800 mb-4">
              Envisioning Responsible AI
            </h2>
            <p className="text-gray-600 mb-4">
              A look into our vision and research activities.
            </p>
          </div>

          {/* Slider Section */}
          <div className="flex justify-center items-center p-8">
            <PhotoSlider images={aboutSliderImages} interval={4000} />
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutSection;
